import React from 'react'
import cn from 'classnames'
import { createPortal } from 'react-dom';

const ExperiencesStepDesktop = ({
  themes,
  data,
  form,
  handleClick,
  onContinueClick,
}) => {
  const footerPortal = document.getElementById('wizard-next-button');

  return (
    <>
      <div className="animate-fade-in">
        <div className="heading-large text-primary">{themes.title}</div>
        <div className="wizard-step__options wizard-experiences-step">
          <div
            className={cn('wizard-experience-type-item slide-in-bottom', {
              'wizard-experience-type-item--active': form.experience?.id === -1,
            })}
            onClick={() => handleClick({ id: -1, text: 'all' })}
          >
            <img src={data.showEverythingImage} alt="all_types_image" />
            <div className="my-auto px-5 heading-tiny text-primary leading-4">{data.showEverythingText}</div>
          </div>
          {themes.items.map((item, index) => (
            <div
              key={item.id}
              className={cn('wizard-experience-type-item slide-in-bottom', {
                'wizard-experience-type-item--active': form.experience?.id === item.id,
                [`animation-delay-${(index + 1)  * 100}`]: true
              })}
              onClick={() => handleClick(item)}
            >
              <img src={item.photo} alt={item.text} />
              <div className="my-auto px-5 heading-tiny text-primary leading-4">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
      {footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={onContinueClick}>
          {data.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </>
  )
}

export default ExperiencesStepDesktop
